<script lang="ts">let { size = "20" } = $props();
</script>

<svg height={size} style="fill: currentColor" viewBox="0 0 31 32" xmlns="http://www.w3.org/2000/svg">
	<path
		d="M1.76607 0L5.50507 6.042V25.935L1.52007 32H24.8811L31.0001 24H14.8891V0H1.76607ZM6.56307 2.667H12.2081V26.667H25.5901L23.5531 29.334H6.47607L8.18607 26.732V5.289L7.98707 4.969L6.56307 2.667ZM17.5711 2.922V5.643C22.9361 6.86 26.9551 11.633 26.9551 17.333C26.9551 18.736 26.7091 20.081 26.2611 21.333H29.0731C29.4361 20.061 29.6361 18.72 29.6361 17.333C29.6361 10.157 24.4241 4.18 17.5711 2.922ZM2.82407 8.927C1.47407 10.838 0.566066 13.076 0.258066 15.5C0.182066 16.1 0.143066 16.712 0.143066 17.333C0.143066 18.081 0.199066 18.816 0.308066 19.534C0.658066 21.817 1.54307 23.926 2.82407 25.74V8.927Z"
	/>
</svg>
